import React from 'react'

import { tokenVar } from '../../theme/tokenVar'

export type GuardsIconProps = {
  size?: number
  color?: string
  colorScheme?: 'dark' | 'light'
  className?: string
}

export const GuardsIcon = ({
  size = 20,
  color,
  colorScheme = 'dark',
  className,
}: GuardsIconProps) => {
  const resolvedColor =
    color ??
    (colorScheme === 'light'
      ? tokenVar('colors.light.icon.secondary')
      : tokenVar('colors.icon.secondary'))
  return (
    <svg
      aria-label='Guards'
      className={className}
      fill='none'
      height={size}
      role='img'
      viewBox='0 0 20 20'
      width={size}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M13.21 13.5132C15.7173 13.5132 17.75 15.5459 17.75 18.0532C17.7499 18.4674 17.4142 18.8032 17 18.8032H3C2.58584 18.8032 2.25009 18.4674 2.25 18.0532C2.25001 15.5459 4.28275 13.5132 6.79004 13.5132H13.21ZM10.5 17.3032H16.1562C15.8223 15.987 14.63 15.0132 13.21 15.0132H10.5V17.3032ZM6.79004 15.0132C5.36999 15.0132 4.17772 15.987 3.84375 17.3032H9V15.0132H6.79004ZM10.0674 1.20068C10.0906 1.20276 10.1137 1.20521 10.1367 1.20947C10.1572 1.21326 10.1772 1.21865 10.1973 1.22412C10.2195 1.2302 10.2418 1.23641 10.2637 1.24463C10.2878 1.25367 10.3108 1.26532 10.334 1.27686C10.3457 1.28275 10.3586 1.28691 10.3701 1.29346L10.3955 1.30908C10.4031 1.31377 10.4106 1.31876 10.418 1.32373L10.5957 1.43701C10.9965 1.66923 11.5713 1.84707 12.2051 1.96631C12.9107 2.09904 13.5976 2.14307 14 2.14307C14.0877 2.14307 14.1708 2.1613 14.249 2.18896C14.4396 2.12111 14.6565 2.12822 14.8496 2.22998C15.2157 2.42319 15.3559 2.87645 15.1631 3.24268L13.75 5.92041V8.73584C13.75 10.8069 12.0711 12.4858 10 12.4858C7.92893 12.4858 6.25 10.8069 6.25 8.73584V5.92041L4.83691 3.24268C4.64408 2.87645 4.78427 2.42319 5.15039 2.22998C5.34323 2.12838 5.55964 2.12145 5.75 2.18896C5.82846 2.1611 5.91199 2.14307 6 2.14307C6.40242 2.14307 7.08929 2.09904 7.79492 1.96631C8.42871 1.84707 9.00349 1.66923 9.4043 1.43701L9.58105 1.32373C9.58845 1.31876 9.59597 1.31377 9.60352 1.30908L9.62988 1.29346C9.64117 1.28705 9.65354 1.28263 9.66504 1.27686C9.68818 1.2653 9.71126 1.25369 9.73535 1.24463C9.75716 1.23639 9.77952 1.23023 9.80176 1.22412C9.82181 1.21863 9.84188 1.21329 9.8623 1.20947C9.88532 1.20519 9.90847 1.20279 9.93164 1.20068C9.95439 1.19859 9.97711 1.19679 10 1.19678C10.0226 1.19679 10.045 1.19865 10.0674 1.20068ZM7.75 8.73584C7.75 9.97848 8.75736 10.9858 10 10.9858C11.2426 10.9858 12.25 9.97848 12.25 8.73584V6.48584H7.75V8.73584ZM10 2.81787C9.4018 3.13048 8.69914 3.32298 8.07227 3.44092C7.59653 3.5304 7.12938 3.58236 6.72656 3.61182L7.45215 4.98584H12.5479L13.2725 3.61182C12.8699 3.58234 12.4031 3.53033 11.9277 3.44092C11.3009 3.32298 10.5982 3.13048 10 2.81787Z'
        fill={resolvedColor}
      />
    </svg>
  )
}
